import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var PictureIcon20Solid = forwardRefAndName('PictureIcon20Solid', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 20
    }, props), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.9876 2.58579C12.6125 2.21071 12.1038 2 11.5734 2H6C4.34315 2 3 3.34315 3 5V15C3 16.6569 4.34315 18 6 18H14C15.6569 18 17 16.6569 17 15V7.42664C17 6.89621 16.7893 6.3875 16.4142 6.01243L12.9876 2.58579ZM9.125 6.50024C9.125 7.39771 8.39746 8.12524 7.5 8.12524C6.60254 8.12524 5.875 7.39771 5.875 6.50024C5.875 5.60278 6.60254 4.87524 7.5 4.87524C8.39746 4.87524 9.125 5.60278 9.125 6.50024ZM10.8264 10.8882C11.1144 10.6002 11.5814 10.6002 11.8694 10.8882L13.548 12.5668C13.8702 12.889 14.3926 12.889 14.7147 12.5668C15.0369 12.2447 15.0369 11.7223 14.7147 11.4001L13.0361 9.72149C12.1037 8.78911 10.5921 8.78911 9.65968 9.72149L5.75428 13.6269C5.4321 13.9491 5.4321 14.4714 5.75428 14.7936C6.07647 15.1158 6.59883 15.1158 6.92101 14.7936L10.8264 10.8882Z"
    }), ' ')
  );
});